const childRoutes = prop => [
    {
        path: 'vagrant-details-report',
        name: prop + '.street_child_details_report',
        meta: { auth: true },
        component: () => import('../pages/vagrant-details-report/List.vue')
    }
]
const routes = [
    {
        path: '/rehabilitation-vagrant-service/report',
        name: 'rehabilitation_vagrant_service.report',
        component: () => import('@/layouts/RehabilitationVagrantService.vue'),
        meta: { auth: true },
        children: childRoutes('rehabilitation_vagrant_service.vagrant')
    }
]

export default routes
